import {defaultTo, isNil, startsWith} from 'ramda';

import {dialCodePrefix} from '../constants';
import {PhoneNumber} from '../types/PhoneNumber';
import {Alpha3CountryCode} from './countryCodes';
import {getFormattedNumber} from './getFormattedNumber';

/**
 * @about Returns default inner value for phone number input.
 * A stored number that already carries its dialling code (e.g. `+48501693323` with prefix `+48`)
 * is shown as stored – prepending the prefix would make libphonenumber truncate it to the prefix only.
 * @param innerCountry
 * @param value
 * @param isNational
 */
export const getDefaultInnerValue = (
  innerCountry: Alpha3CountryCode,
  value?: PhoneNumber,
  isNational?: true
): string => {
  if (isNil(value)) {
    return '';
  }

  const number = defaultTo('', value.number);
  const shouldPrependPrefix = !isNational && !startsWith(dialCodePrefix, number);
  const prefix = shouldPrependPrefix ? defaultTo('', value.prefix) : '';

  return getFormattedNumber(`${prefix}${number}`, innerCountry);
};
